import React from 'react';
import NewChatButton from './NewChatButton';
import ExpandChatButton from './ExpandChatButton';
import styles from '../ChatWidget.module.scss';

interface ChatHeaderProps {
  onMinimize: () => void;
  onClose: () => void;
  onExpand: (conversationId: number | null) => void;
}

export default function ChatHeader(props: ChatHeaderProps) {
  return (
    <div className={styles.header} data-testid="chat-header">
      <div className={styles.headerInfo}>
        <div className={styles.headerAvatar}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="14" rx="3" stroke="white" strokeWidth="1.5" />
            <circle cx="9" cy="10" r="1.5" fill="white" />
            <circle cx="15" cy="10" r="1.5" fill="white" />
            <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M6 4V2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M18 4V2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
        <div className={styles.headerText}>
          <div className={styles.headerTitle}>Nekst AI</div>
          <div className={styles.headerSubtitle}>Online</div>
        </div>
      </div>
      <div className={styles.headerActions}>
        <NewChatButton />
        <ExpandChatButton onExpand={props.onExpand} />
        <button
          type="button"
          className={styles.headerButton}
          onClick={props.onMinimize}
          aria-label="Minimize chat"
        >
          &ndash;
        </button>
        <button
          type="button"
          className={styles.headerButton}
          onClick={props.onClose}
          aria-label="Close chat"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
